import { IsDevelopment, SVMDateFormat, HostNames } from "../constants";
import * as moment from 'moment';
import { isDateStringNullOrEmpty } from './validator';

// normally .includes(HostNames.Soundmouse), but IE is considered a "browser" and therefore 
// it needs indexOf
export const IsSoundmouse = window.location.hostname.indexOf(HostNames.Soundmouse) > -1;

export function toFormattedDate(date, isShortMonth = true) {
    if (isDateStringNullOrEmpty(date)) {
        return '';
    }

    var monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
    ];
    var formattedDate = new Date(date);
    var day = formattedDate.getDate();
    var monthIndex = formattedDate.getMonth();
    var year = formattedDate.getFullYear();
    var month = monthNames[monthIndex].substring(0, 3);
    if (!isShortMonth)
        month = monthNames[monthIndex];

    if (day === 1 && monthIndex === 0 && year === 1)
        return '';

    return pad(day, 2) + '-' + month + '-' + year;
}

export function toFormattedShortDate(dateString) {
    if (isDateStringNullOrEmpty(dateString)) {
        return '';
    }

    var formattedDate = new Date(dateString);
    var day = formattedDate.getDate();
    var month = formattedDate.getMonth() + 1;
    var year = formattedDate.getFullYear();

    return pad(day, 2) + '/' + pad(month, 2) + '/' + year;
}

export function toFormattedDatetime(datetime) {
    if (isDateStringNullOrEmpty(datetime)) {
        return '';
    }

    var monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
    ];

    var formattedDate = new Date(datetime);
    var day = formattedDate.getDate();
    var monthIndex = formattedDate.getMonth();
    var year = formattedDate.getFullYear();
    var hours = formattedDate.getHours();
    var minutes = formattedDate.getMinutes();
    var seconds = formattedDate.getSeconds();

    return pad(day, 2) + '-' + monthNames[monthIndex].substring(0, 3) + '-' + year + '  ' + pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2);
}


export function toDate(dateAsString, dateFormat = SVMDateFormat) {
    if (isDateStringNullOrEmpty(dateAsString)) {
        return undefined;
    }

    return moment(dateAsString, dateFormat).toDate();
}

export function toMoment(date) {
    if (date)
        return moment(date);

    return null;
}

export function stringToMoment(date, dateFormat = SVMDateFormat) {
    if (date)
        return moment(date, dateFormat);

    return null;
}

export function writeConsoleLog(message) {
    if (IsDevelopment)
        console.log(message);
}

export function getCorsPolicy() {
    if (IsDevelopment) {
        return 'include';
    }
    else {
        return 'same-origin';
    }
}

function pad(number, length, paddingValue = '0', padLeft = true) {

    var str = '' + number;

    while (str.length < length) {
        if (padLeft)
            str = paddingValue + str;
        else
            str = str + paddingValue;
    }

    return str;
}

export function getApiUri(value) {
    if (!IsDevelopment)
        return value;

    return value.replace('api/', '').replace('auth/', '');
}

export function getQueryObject(query) {
    const arr = query.slice(1).split(/&|=/);
    let params = {};
    for (let i = 0; i < arr.length; i += 2) {
        let key = arr[i], value = arr[i + 1];
        params[key] = value;
    }
    return params;
}

export function sanitizeParameterValue(value) {

    if (value) {
        return value.split('&')[0];
    }

    return '';
}

export function getMandatoryBgCss(validationList, entityName, identifierName) {
    if (validationList) {
        let identify = validationList.filter((element) => element.entity === entityName)[0];
        if (identify && identify.identifiers && identify.identifiers.filter((item) => item === identifierName)[0])
            return 'mandatoryBg';
    }

    return '';
}

export function getStyleVisibility(required) {
    if (required === 'true' || required === true)
        return 'visible';

    return 'hidden';
}


// WEBPACK FOOTER //
// ./src/tools/toolkit.js